import {IMessageData, IObjectData} from "../../../index";
import * as ko from "knockout";
import {getSyncFieldValue} from "../../../util/misc";
import PromiseRequest from "../../../req/PromiseRequest";
import {global} from "../../../appContext";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import idHtml from './id.html?raw';

export let template: string = idHtml;

interface IParams {
    id: string // the eAdm object id
    showIcon?: boolean
    target?: string
    orgnr?: IObjectData['companyid']
}

export class viewModel {
    isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);

    name: string | null = null;
    id: number | null = null;
    orgnr: string | null = null;
    readonly target: string | undefined

    private req_getobject!: PromiseRequest

    constructor(private params: IParams) {
        this.target = params.target
        this.orgnr = params.orgnr ?? global.login.selectedOrganizationId()
        this.request();
    }

    protected request() {

        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE, type: "info"});

        Promise.resolve()
            .then(() => {
                this.req_getobject = new PromiseRequest('getobject')
                return this.req_getobject
                    .request({
                        id: this.params.id,
                        manual: false,
                        orgnr: this.orgnr,
                    })
                    .catch(() => {
                        const user = global.login.user();
                        if (!user) {
                            throw new Error('not logged in');
                        }
                        this.orgnr = user.orgnr;
                        this.req_getobject = new PromiseRequest('getobject')
                        return this.req_getobject
                            .request({
                                id: this.params.id,
                                manual: false,
                                orgnr: this.orgnr,
                            });
                    })
            })
            .then((data: IObjectData[]) => {
                this.messageData(null);
                const d = data[0];
                if (d) {
                    this.name = getSyncFieldValue(["DisplayName"], d.syncfields);
                    this.id = d.id;
                    this.isReady(true);
                } else {
                    this.messageData({message: "data not available", type: "warning"});
                }
            })
            .catch((reason: string) => {
                this.messageData({message: `data not available`, type: "warning"});
            });
    }

    private onUserClick() {
        const newOrg = this.orgnr;
        const oldOrg = global.login.selectedOrganizationId();
        if (newOrg && newOrg != oldOrg) {
            global.login.setSelectedOrganizationById(newOrg);
        }
        return true;
    }

    dispose() {
        this.req_getobject?.abort()
    }

}
